export default __webpack_public_path__ + "static/media/Yousun.0bd1eb16.png";